import { useState, useEffect } from "react"

const useDeviceBreakpoint = () => {
  const [device, setDevice] = useState<"mobile" | "tablet" | "desktop">(() => {
    if (typeof window === "undefined") return "desktop"

    const width = window.innerWidth
    if (width < 768) return "mobile"
    if (width < 1024) return "tablet"
    return "desktop"
  })

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      if (width < 768) setDevice("mobile")
      else if (width < 1024) setDevice("tablet")
      else setDevice("desktop")
    }

    const mobileQuery = window.matchMedia("(max-width: 767px)")
    const tabletQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1023px)",
    )

    const updateDevice = () => handleResize()

    mobileQuery.addListener(updateDevice)
    tabletQuery.addListener(updateDevice)
    window.addEventListener("resize", handleResize)

    return () => {
      mobileQuery.removeListener(updateDevice)
      tabletQuery.removeListener(updateDevice)
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return {
    isMobile: device === "mobile",
    isTablet: device === "tablet",
    isDesktop: device === "desktop",
    device,
  }
}

export default useDeviceBreakpoint
